// import React, { useState } from "react";
// import "./contact_us.css";
// import contactImage from "../../img/des_sec/contact-image.png";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import emailjs from "@emailjs/browser";

// const ContactModal = ({ isOpen, onClose }) => {
//   const [name, setName] = useState("");
//   const [email, setEmail] = useState("");
//   const [mobile, setMobile] = useState("");
//   const [message, setMessage] = useState("");
//   const [subject, setSubject] = useState("");
//   const [emailError, setEmailError] = useState("");
//   const [loading, setLoading] = useState(false);

//   const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // Email validation
//     let isValid = true;
//     if (!isValidEmail(email)) {
//       setEmailError("Invalid email format");
//       isValid = false;
//     } else {
//       setEmailError("");
//     }

//     if (!isValid) return;

//     setLoading(true);

//     const formattedMessage = `
//       Name: ${name}
//       Email: ${email}
//       Mobile Number: ${mobile}
//       Subject: ${subject}

//       Message:
//       ${message}

//       Regards,
//       Your Website Contact Form
//     `;

//     const templateParams = {
//       to_name: "Wikiworks Team",
//       from_name: name,
//       email,
//       mobile,
//       subject,
//       message: formattedMessage,
//     };

//     try {
//       const response = await emailjs.send(
//         "service_1e5xeqo",
//         "template_6ees2pr",
//         templateParams,
//         "piFdp5IfrbeQZ9qA-"
//       );

//       console.log("EmailJS response:", response); // Debug log
      
//       if (response.status === 200) {
//         toast.success(
//           "Email Sent Successfully! We will be reaching out to you soon",
//           { 
//             position: "top-center", 
//             autoClose: 3000, 
//             style: { 
//               marginTop: "0px",
//               zIndex: 999999 // Ensure it's above other elements
//             },
//             onClose: () => onClose() // Close modal when toast closes
//           }
//         );
        
//         // Reset form fields
//         setName("");
//         setEmail("");
//         setMobile("");
//         setMessage("");
//         setSubject("");
//       } else {
//         throw new Error("Email failed to send");
//       }
//     } catch (error) {
//       console.error("Error sending email:", error);
//       toast.error("Failed to send the email. Please try again later.", {
//         position: "top-center",
//         autoClose: 3000,
//         style: { 
//           marginTop: "0px",
//           zIndex: 999999
//         },
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (!isOpen) return null;

//   return (
//     <>
//       <div className="contact-modal-overlay" onClick={onClose}>
//         <div className="contact-modal" onClick={(e) => e.stopPropagation()}>
//           <button className="modal-close-btn" onClick={onClose}>
//             &times;
//           </button>

//           <div className="modal-content-c">
//             {/* Left Side - Form */}
//             <div className="modal-form-section">
//               <h2>Contact Us</h2>
//               <form onSubmit={handleSubmit}>
//                 <input
//                   type="text"
//                   placeholder="Name"
//                   value={name}
//                   onChange={(e) => setName(e.target.value)}
//                   required
//                 />
//                 <input
//                   type="email"
//                   placeholder="Email"
//                   value={email}
//                   onChange={(e) => {
//                     setEmail(e.target.value);
//                     if (emailError) setEmailError("");
//                   }}
//                   required
//                 />
//                 {emailError && <div className="error-message">{emailError}</div>}
//                 <input
//                   type="tel"
//                   placeholder="Mobile Number"
//                   value={mobile}
//                   onChange={(e) => setMobile(e.target.value)}
//                 />
//                 <input
//                   type="text"
//                   placeholder="Subject"
//                   value={subject}
//                   onChange={(e) => setSubject(e.target.value)}
//                   required
//                 />
//                 <textarea
//                   placeholder="Message"
//                   value={message}
//                   onChange={(e) => setMessage(e.target.value)}
//                   required
//                 ></textarea>
//                 <button type="submit" disabled={loading}>
//                   {loading ? (
//                     <>
//                       <span className="spinner"></span> Sending...
//                     </>
//                   ) : (
//                     "Send Message"
//                   )}
//                 </button>
//               </form>
//             </div>

//             {/* Right Side - Image */}
//             <div className="modal-image-section">
//               <img src={contactImage} alt="Contact illustration" />
//             </div>
//           </div>
//         </div>
//       </div>
//       <ToastContainer 
//         position="top-center"
//         autoClose={3000}
//         hideProgressBar={false}
//         newestOnTop={false}
//         closeOnClick
//         rtl={false}
//         pauseOnFocusLoss
//         draggable
//         pauseOnHover
//         style={{ zIndex: 999999 }}
//       />
//     </>
//   );
// };

// export default ContactModal;

// import React, { useState, useEffect } from "react";
// import { useSpring, animated } from 'react-spring';
// import "./contact_us.css";
// import contactImage from "../../img/des_sec/contact-image.png";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import emailjs from "@emailjs/browser";

// const ContactModal = ({ isOpen, onClose }) => {
//   const [name, setName] = useState("");
//   const [email, setEmail] = useState("");
//   const [mobile, setMobile] = useState("");
//   const [message, setMessage] = useState("");
//   const [subject, setSubject] = useState("");
//   const [emailError, setEmailError] = useState("");
//   const [loading, setLoading] = useState(false);

//   const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

//   // Animation for modal overlay
//   const overlayAnimation = useSpring({
//     opacity: isOpen ? 1 : 0,
//     config: { 
//       tension: 200, 
//       friction: 25,
//       mass: 1
//     }
//   });

//   // Animation for modal container
//   const modalAnimation = useSpring({
//     opacity: isOpen ? 1 : 0,
//     transform: isOpen ? 'scale(1) translateY(0px)' : 'scale(0.9) translateY(-20px)',
//     config: { 
//       tension: 180, 
//       friction: 20,
//       mass: 1
//     }
//   });

//   // Animation for close button
//   const closeButtonAnimation = useSpring({
//     opacity: isOpen ? 1 : 0,
//     transform: isOpen ? 'rotate(0deg) scale(1)' : 'rotate(90deg) scale(0.8)',
//     config: { 
//       tension: 160, 
//       friction: 18,
//       mass: 0.8
//     },
//     delay: isOpen ? 100 : 0
//   });

//   // Animation for form section
//   const formSectionAnimation = useSpring({
//     opacity: isOpen ? 1 : 0,
//     transform: isOpen ? 'translateX(0px)' : 'translateX(-30px)',
//     config: { 
//       tension: 150, 
//       friction: 25,
//       mass: 1
//     },
//     delay: isOpen ? 150 : 0
//   });

//   // Animation for form heading
//   const headingAnimation = useSpring({
//     opacity: isOpen ? 1 : 0,
//     transform: isOpen ? 'translateY(0px)' : 'translateY(15px)',
//     config: { 
//       tension: 140, 
//       friction: 20,
//       mass: 0.8
//     },
//     delay: isOpen ? 200 : 0
//   });

//   // Animation for form inputs (staggered)
//   const input1Animation = useSpring({
//     opacity: isOpen ? 1 : 0,
//     transform: isOpen ? 'translateY(0px)' : 'translateY(10px)',
//     config: { 
//       tension: 130, 
//       friction: 18,
//       mass: 0.7
//     },
//     delay: isOpen ? 250 : 0
//   });

//   const input2Animation = useSpring({
//     opacity: isOpen ? 1 : 0,
//     transform: isOpen ? 'translateY(0px)' : 'translateY(10px)',
//     config: { 
//       tension: 130, 
//       friction: 18,
//       mass: 0.7
//     },
//     delay: isOpen ? 300 : 0
//   });

//   const input3Animation = useSpring({
//     opacity: isOpen ? 1 : 0,
//     transform: isOpen ? 'translateY(0px)' : 'translateY(10px)',
//     config: { 
//       tension: 130, 
//       friction: 18,
//       mass: 0.7
//     },
//     delay: isOpen ? 350 : 0
//   });

//   const input4Animation = useSpring({
//     opacity: isOpen ? 1 : 0,
//     transform: isOpen ? 'translateY(0px)' : 'translateY(10px)',
//     config: { 
//       tension: 130, 
//       friction: 18,
//       mass: 0.7
//     },
//     delay: isOpen ? 400 : 0
//   });

//   const textareaAnimation = useSpring({
//     opacity: isOpen ? 1 : 0,
//     transform: isOpen ? 'translateY(0px)' : 'translateY(10px)',
//     config: { 
//       tension: 130, 
//       friction: 18,
//       mass: 0.7
//     },
//     delay: isOpen ? 450 : 0
//   });

//   const buttonAnimation = useSpring({
//     opacity: isOpen ? 1 : 0,
//     transform: isOpen ? 'translateY(0px) scale(1)' : 'translateY(10px) scale(0.95)',
//     config: { 
//       tension: 120, 
//       friction: 16,
//       mass: 0.8
//     },
//     delay: isOpen ? 500 : 0
//   });

//   // Animation for image section
//   const imageSectionAnimation = useSpring({
//     opacity: isOpen ? 1 : 0,
//     transform: isOpen ? 'translateX(0px) scale(1)' : 'translateX(30px) scale(0.95)',
//     config: { 
//       tension: 150, 
//       friction: 25,
//       mass: 1.2
//     },
//     delay: isOpen ? 200 : 0
//   });

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // Email validation
//     let isValid = true;
//     if (!isValidEmail(email)) {
//       setEmailError("Invalid email format");
//       isValid = false;
//     } else {
//       setEmailError("");
//     }

//     if (!isValid) return;

//     setLoading(true);

//     const formattedMessage = `
//       Name: ${name}
//       Email: ${email}
//       Mobile Number: ${mobile}
//       Subject: ${subject}

//       Message:
//       ${message}

//       Regards,
//       Your Website Contact Form
//     `;

//     const templateParams = {
//       to_name: "Wikiworks Team",
//       from_name: name,
//       email,
//       mobile,
//       subject,
//       message: formattedMessage,
//     };

//     try {
//       const response = await emailjs.send(
//         "service_1e5xeqo",
//         "template_6ees2pr",
//         templateParams,
//         "piFdp5IfrbeQZ9qA-"
//       );

//       console.log("EmailJS response:", response);
      
//       if (response.status === 200) {
//         toast.success(
//           "Email Sent Successfully! We will be reaching out to you soon",
//           { 
//             position: "top-center", 
//             autoClose: 3000, 
//             style: { 
//               marginTop: "0px",
//               zIndex: 999999
//             },
//             onClose: () => onClose()
//           }
//         );
        
//         // Reset form fields
//         setName("");
//         setEmail("");
//         setMobile("");
//         setMessage("");
//         setSubject("");
//       } else {
//         throw new Error("Email failed to send");
//       }
//     } catch (error) {
//       console.error("Error sending email:", error);
//       toast.error("Failed to send the email. Please try again later.", {
//         position: "top-center",
//         autoClose: 3000,
//         style: { 
//           marginTop: "0px",
//           zIndex: 999999
//         },
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (!isOpen) return null;

//   return (
//     <>
//       <animated.div 
//         className="contact-modal-overlay" 
//         onClick={onClose}
//         style={overlayAnimation}
//       >
//         <animated.div 
//           className="contact-modal" 
//           onClick={(e) => e.stopPropagation()}
//           style={modalAnimation}
//         >
//           <animated.button 
//             className="modal-close-btn" 
//             onClick={onClose}
//             style={closeButtonAnimation}
//           >
//             &times;
//           </animated.button>

//           <div className="modal-content-c">
//             {/* Left Side - Form */}
//             <animated.div 
//               className="modal-form-section"
//               style={formSectionAnimation}
//             >
//               <animated.h2 style={headingAnimation}>
//                 Contact Us
//               </animated.h2>
//               <form onSubmit={handleSubmit}>
//                 <animated.input
//                   type="text"
//                   placeholder="Name"
//                   value={name}
//                   onChange={(e) => setName(e.target.value)}
//                   required
//                   style={input1Animation}
//                 />
//                 <animated.input
//                   type="email"
//                   placeholder="Email"
//                   value={email}
//                   onChange={(e) => {
//                     setEmail(e.target.value);
//                     if (emailError) setEmailError("");
//                   }}
//                   required
//                   style={input2Animation}
//                 />
//                 {emailError && <div className="error-message">{emailError}</div>}
//                 <animated.input
//                   type="tel"
//                   placeholder="Mobile Number"
//                   value={mobile}
//                   onChange={(e) => setMobile(e.target.value)}
//                   style={input3Animation}
//                 />
//                 <animated.input
//                   type="text"
//                   placeholder="Subject"
//                   value={subject}
//                   onChange={(e) => setSubject(e.target.value)}
//                   required
//                   style={input4Animation}
//                 />
//                 <animated.textarea
//                   placeholder="Message"
//                   value={message}
//                   onChange={(e) => setMessage(e.target.value)}
//                   required
//                   style={textareaAnimation}
//                 ></animated.textarea>
//                 <animated.button 
//                   type="submit" 
//                   disabled={loading}
//                   style={buttonAnimation}
//                 >
//                   {loading ? (
//                     <>
//                       <span className="spinner"></span> Sending...
//                     </>
//                   ) : (
//                     "Send Message"
//                   )}
//                 </animated.button>
//               </form>
//             </animated.div>

//             {/* Right Side - Image */}
//             <animated.div 
//               className="modal-image-section"
//               style={imageSectionAnimation}
//             >
//               <img src={contactImage} alt="Contact illustration" />
//             </animated.div>
//           </div>
//         </animated.div>
//       </animated.div>
//       <ToastContainer 
//         position="top-center"
//         autoClose={3000}
//         hideProgressBar={false}
//         newestOnTop={false}
//         closeOnClick
//         rtl={false}
//         pauseOnFocusLoss
//         draggable
//         pauseOnHover
//         style={{ zIndex: 999999 }}
//       />
//     </>
//   );
// };

// export default ContactModal;


import React, { useState } from "react";
import { useSpring, animated } from 'react-spring';
import "./contact_us.css";
import contactImage from "../../img/des_sec/contact-image.png";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import emailjs from "@emailjs/browser";

const ContactModal = ({ isOpen, onClose }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [message, setMessage] = useState("");
  const [subject, setSubject] = useState("");
  const [emailError, setEmailError] = useState("");
  const [loading, setLoading] = useState(false);
  const [privacyChecked, setPrivacyChecked] = useState(false);

  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  // Open privacy policy PDF
  const openPrivacyPolicy = () => {
    // Replace with your actual PDF URL
    window.open('/privacypolicy', '_blank');
  };

  // Define all animations at the top of the component
  const overlayAnimation = useSpring({
    opacity: isOpen ? 1 : 0,
    config: { 
      tension: 200, 
      friction: 25,
      mass: 1
    }
  });

  const modalAnimation = useSpring({
    opacity: isOpen ? 1 : 0,
    transform: isOpen ? 'scale(1) translateY(0px)' : 'scale(0.9) translateY(-20px)',
    config: { 
      tension: 180, 
      friction: 20,
      mass: 1
    }
  });

  const closeButtonAnimation = useSpring({
    opacity: isOpen ? 1 : 0,
    transform: isOpen ? 'rotate(0deg) scale(1)' : 'rotate(90deg) scale(0.8)',
    config: { 
      tension: 160, 
      friction: 18,
      mass: 0.8
    },
    delay: isOpen ? 100 : 0
  });

  const formSectionAnimation = useSpring({
    opacity: isOpen ? 1 : 0,
    transform: isOpen ? 'translateX(0px)' : 'translateX(-30px)',
    config: { 
      tension: 150, 
      friction: 25,
      mass: 1
    },
    delay: isOpen ? 150 : 0
  });

  const headingAnimation = useSpring({
    opacity: isOpen ? 1 : 0,
    transform: isOpen ? 'translateY(0px)' : 'translateY(15px)',
    config: { 
      tension: 140, 
      friction: 20,
      mass: 0.8
    },
    delay: isOpen ? 200 : 0
  });

  const input1Animation = useSpring({
    opacity: isOpen ? 1 : 0,
    transform: isOpen ? 'translateY(0px)' : 'translateY(10px)',
    config: { 
      tension: 130, 
      friction: 18,
      mass: 0.7
    },
    delay: isOpen ? 250 : 0
  });

  const input2Animation = useSpring({
    opacity: isOpen ? 1 : 0,
    transform: isOpen ? 'translateY(0px)' : 'translateY(10px)',
    config: { 
      tension: 130, 
      friction: 18,
      mass: 0.7
    },
    delay: isOpen ? 300 : 0
  });

  const input3Animation = useSpring({
    opacity: isOpen ? 1 : 0,
    transform: isOpen ? 'translateY(0px)' : 'translateY(10px)',
    config: { 
      tension: 130, 
      friction: 18,
      mass: 0.7
    },
    delay: isOpen ? 350 : 0
  });

  const input4Animation = useSpring({
    opacity: isOpen ? 1 : 0,
    transform: isOpen ? 'translateY(0px)' : 'translateY(10px)',
    config: { 
      tension: 130, 
      friction: 18,
      mass: 0.7
    },
    delay: isOpen ? 400 : 0
  });

  const textareaAnimation = useSpring({
    opacity: isOpen ? 1 : 0,
    transform: isOpen ? 'translateY(0px)' : 'translateY(10px)',
    config: { 
      tension: 130, 
      friction: 18,
      mass: 0.7
    },
    delay: isOpen ? 450 : 0
  });

  const buttonAnimation = useSpring({
    opacity: isOpen ? 1 : 0,
    transform: isOpen ? 'translateY(0px) scale(1)' : 'translateY(10px) scale(0.95)',
    config: { 
      tension: 120, 
      friction: 16,
      mass: 0.8
    },
    delay: isOpen ? 500 : 0
  });

  const imageSectionAnimation = useSpring({
    opacity: isOpen ? 1 : 0,
    transform: isOpen ? 'translateX(0px) scale(1)' : 'translateX(30px) scale(0.95)',
    config: { 
      tension: 150, 
      friction: 25,
      mass: 1.2
    },
    delay: isOpen ? 200 : 0
  });

  const checkboxAnimation = useSpring({
    opacity: isOpen ? 1 : 0,
    transform: isOpen ? 'translateY(0px)' : 'translateY(10px)',
    config: { 
      tension: 130, 
      friction: 18,
      mass: 0.7
    },
    delay: isOpen ? 550 : 0
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if privacy policy is accepted
    if (!privacyChecked) {
      toast.error("Please accept the privacy policy to proceed", {
        position: "top-center",
        autoClose: 3000,
        style: { 
          marginTop: "0px",
          zIndex: 999999
        },
      });
      return;
    }

    // Email validation
    let isValid = true;
    if (!isValidEmail(email)) {
      setEmailError("Invalid email format");
      isValid = false;
    } else {
      setEmailError("");
    }

    if (!isValid) return;

    setLoading(true);

    const formattedMessage = `
      Name: ${name}
      Email: ${email}
      Mobile Number: ${mobile}
      Subject: ${subject}

      Message:
      ${message}

      Regards,
      Your Website Contact Form
    `;

    const templateParams = {
      to_name: "Wikiworks Team",
      from_name: name,
      email,
      mobile,
      subject,
      message: formattedMessage,
    };

    try {
      const response = await emailjs.send(
        "service_1e5xeqo",
        "template_6ees2pr",
        templateParams,
        "piFdp5IfrbeQZ9qA-"
      );

      console.log("EmailJS response:", response);
      
      if (response.status === 200) {
        toast.success(
          "Email Sent Successfully! We will be reaching out to you soon",
          { 
            position: "top-center", 
            autoClose: 3000, 
            style: { 
              marginTop: "0px",
              zIndex: 999999
            },
            onClose: () => onClose()
          }
        );
        
        // Reset form fields
        setName("");
        setEmail("");
        setMobile("");
        setMessage("");
        setSubject("");
        setPrivacyChecked(false);
      } else {
        throw new Error("Email failed to send");
      }
    } catch (error) {
      console.error("Error sending email:", error);
      toast.error("Failed to send the email. Please try again later.", {
        position: "top-center",
        autoClose: 3000,
        style: { 
          marginTop: "0px",
          zIndex: 999999
        },
      });
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <>
      <animated.div 
        className="contact-modal-overlay" 
        onClick={onClose}
        style={overlayAnimation}
      >
        <animated.div 
          className="contact-modal" 
          onClick={(e) => e.stopPropagation()}
          style={modalAnimation}
        >
          <animated.button 
            className="modal-close-btn" 
            onClick={onClose}
            style={closeButtonAnimation}
          >
            &times;
          </animated.button>

          <div className="modal-content-c">
            {/* Left Side - Form */}
            <animated.div 
              className="modal-form-section"
              style={formSectionAnimation}
            >
              <animated.h2 style={headingAnimation}>
                Contact Us
              </animated.h2>
              <form onSubmit={handleSubmit}>
                <animated.input
                  type="text"
                  placeholder="Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                  style={input1Animation}
                />
                <animated.input
                  type="email"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    if (emailError) setEmailError("");
                  }}
                  required
                  style={input2Animation}
                />
                {emailError && <div className="error-message">{emailError}</div>}
                <animated.input
                  type="tel"
                  placeholder="Mobile Number"
                  value={mobile}
                  onChange={(e) => setMobile(e.target.value)}
                  style={input3Animation}
                />
                <animated.input
                  type="text"
                  placeholder="Subject"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                  required
                  style={input4Animation}
                />
                <animated.textarea
                  placeholder="Message"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  required
                  style={textareaAnimation}
                ></animated.textarea>
                
                {/* Privacy Policy Checkbox */}
                <animated.div className="privacy-checkbox" style={checkboxAnimation}>
                  <input
                    type="checkbox"
                    id="privacyCheckbox"
                    checked={privacyChecked}
                    onChange={(e) => setPrivacyChecked(e.target.checked)}
                  />
                  <label htmlFor="privacyCheckbox">
                    I have read and accept the{' '}
                    <span 
                      className="privacy-link" 
                      onClick={openPrivacyPolicy}
                    >
                      Privacy Policy
                    </span>
                  </label>
                </animated.div>
                
                <animated.button 
                  type="submit" 
                  disabled={loading || !privacyChecked}
                  style={buttonAnimation}
                  className={!privacyChecked ? 'disabled-button' : ''}
                >
                  {loading ? (
                    <>
                      <span className="spinner"></span> Sending...
                    </>
                  ) : (
                    "Send Message"
                  )}
                </animated.button>
              </form>
            </animated.div>

            {/* Right Side - Image */}
            <animated.div 
              className="modal-image-section"
              style={imageSectionAnimation}
            >
              <img src={contactImage} alt="Contact illustration" />
            </animated.div>
          </div>
        </animated.div>
      </animated.div>
      <ToastContainer 
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        style={{ zIndex: 999999 }}
      />
    </>
  );
};

export default ContactModal;